module.exports = require("janis");


//////////////////
// WEBPACK FOOTER
// external "janis"
// module id = 6
// module chunks = 0